<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">月份:</div>
                <el-date-picker
                v-model="conditionData.dataTime"
                type="month"
                size="small" 
                value-format="yyyy-MM-dd"
                placeholder="选择月">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">险种类型:</div>
                <el-select v-model="conditionData.cProdType" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                    <el-option
                    v-for="item in insuranceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>

                <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>

            </div>
            <div class="title">
                意健险案件日接案数据通报（当月）
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600px"
                style="width: 100%">
                
                <el-table-column
                prop="mechanismName"
                label="机构/日期"
                align="center"
                width="180"
                fixed="left"
                >
                </el-table-column>
                <el-table-column
                prop="one"
                label="1日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="two"
                label="2日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="three"
                label="3日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="four"
                label="4日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="five"
                label="5日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="six"
                label="6日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="seven"
                label="7日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="eight"
                label="8日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="nine"
                label="9日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="ten"
                label="10日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="eleven"
                label="11日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twelve"
                label="12日"
                align="center"
                width="100"
                >
                </el-table-column>
                
                <el-table-column
                prop="thirteen"
                label="13日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="fourteen"
                label="14日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="fifteen"
                label="15日"
                align="center"
                width="100"
                >
                </el-table-column>




                <el-table-column
                prop="sixteen"
                label="16日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="seventeen"
                label="17日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="eighteen"
                label="18日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="nineteen"
                label="19日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twenty"
                label="20日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentyone"
                label="21日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentytwo"
                label="22日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentythree"
                label="23日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentyfour"
                label="24日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentyfive"
                label="25日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentysix"
                label="26日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentyseven"
                label="27日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentyeight"
                label="28日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="twentynine"
                label="29日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="thirty"
                label="30日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="thirtyone"
                label="31日"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="heji"
                label="合计"
                align="center"
                fixed="right"
                width="150"
                >
                </el-table-column>
            </el-table>

        </div>


        
       
    </div>
</template>
<script>
import api from '../../../api/main'
import { insuranceList } from "../../../assets/selectList/anxin";
import { parseTimeNowMM } from '../../../utils/index'

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            insuranceList:insuranceList,
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                dataTime:null,
                cProdType:'',
                operatorMechanismId:localStorage.getItem('mechanismid'),
                page:1,
                pageSize:10,
            },
            tableData:[],
        }
    },
    created(){
        

    },
    mounted(){
        this.conditionData.dataTime = parseTimeNowMM()
        this.loadingData();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let option = {
                cProdType:this.conditionData.cProdType,
                page:this.conditionData.page,
                pageSize:this.conditionData.pageSize,
            };
            
            if(this.conditionData.dataTime){
                option.dataTime = this.conditionData.dataTime
            }
            let res  = await api.queryDataCensusDay(option);
            console.log(res);
            this.tableData = res.data.data;
            let heji = {
                mechanismName:'合计',
                eight:0,
                eighteen:0,
                eleven:0,
                fifteen:0,
                five:0,
                four:0,
                fourteen:0,
                heji:0,
                nine:0,
                nineteen:0,
                one:0,
                seven:0,
                seventeen:0,
                six:0,
                sixteen:0,
                ten:0,
                thirteen:0,
                thirty:0,
                thirtyone:0,
                three:0,
                twelve:0,
                twenty:0,
                twentyeight:0,
                twentyfive:0,
                twentyfour:0,
                twentynine:0,
                twentyone:0,
                twentyseven:0,
                twentysix:0,
                twentythree:0,
                twentytwo:0,
                two:0,
            };
            for(let index in this.tableData){
                heji.eight = heji.eight+ this.tableData[index].eight;
                heji.eighteen = heji.eighteen+ this.tableData[index].eighteen;
                heji.eleven = heji.eleven+ this.tableData[index].eleven;
                heji.fifteen = heji.fifteen+ this.tableData[index].fifteen;
                heji.five = heji.five+ this.tableData[index].five;
                heji.four = heji.four+ this.tableData[index].four;
                heji.fourteen = heji.fourteen+ this.tableData[index].fourteen;
                heji.heji = heji.heji+ this.tableData[index].heji;
                heji.nine = heji.nine+ this.tableData[index].nine;
                heji.nineteen = heji.nineteen+ this.tableData[index].nineteen;
                heji.one = heji.one+ this.tableData[index].one;
                heji.seven = heji.seven+ this.tableData[index].seven;
                heji.seventeen = heji.seventeen+ this.tableData[index].seventeen;
                heji.six = heji.six+ this.tableData[index].six;
                heji.sixteen = heji.sixteen+ this.tableData[index].sixteen;
                heji.ten = heji.ten+ this.tableData[index].ten;
                heji.thirteen = heji.thirteen+ this.tableData[index].thirteen;
                heji.thirty = heji.thirty+ this.tableData[index].thirty;
                heji.thirtyone = heji.thirtyone+ this.tableData[index].thirtyone;
                heji.three = heji.three+ this.tableData[index].three;
                heji.twelve = heji.twelve+ this.tableData[index].twelve;
                heji.twenty = heji.twenty+ this.tableData[index].twenty;
                heji.twentyeight = heji.twentyeight+ this.tableData[index].twentyeight;
                heji.twentyfive = heji.twentyfive+ this.tableData[index].twentyfive;
                heji.twentyfour = heji.twentyfour+ this.tableData[index].twentyfour;
                heji.twentynine = heji.twentynine+ this.tableData[index].twentynine;
                heji.twentyone = heji.twentyone+ this.tableData[index].twentyone;
                heji.twentyseven = heji.twentyseven+ this.tableData[index].twentyseven;
                heji.twentysix = heji.twentysix+ this.tableData[index].twentysix;
                heji.twentythree = heji.twentythree+ this.tableData[index].twentythree;
                heji.twentytwo = heji.twentytwo+ this.tableData[index].twentytwo;
                heji.two = heji.two+ this.tableData[index].two;
            }
            this.tableData.push(heji)  
        },

        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                dataTime:null,
                cProdType:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 5,
                "Condition":this.conditionData
            },'意健险案件日接案数据通报');
        },

    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 10px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .title{
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: bold;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
